import * as actionTypes from "./actionTypes";
import auth from '../services/authentication';
import Api from '../api/Api';
import { Dispatch } from 'redux';

export function searchFieldAction(text:string) {
  return ({
    type: actionTypes.SEARCH_FIELD_CHANGED,
    payload: text,
  })
}

export function getGmailLoginLink() {
  return (dispatch: Dispatch<any>) => {
    dispatch({type: actionTypes.GET_GMAIL_LOGIN_LINK_FETCHED})

    Api.getGmailLoginLink()
      .then(res => {
        dispatch({
          type: actionTypes.GET_GMAIL_LOGIN_LINK_SUCCESS,
          payload: res.data,
        })
      })
      .catch(err => {
        dispatch({
          type: actionTypes.GET_GMAIL_LOGIN_LINK_FAILED,
          payload: err
        })
      })
  }
}

export function getSlackLoginLink() {
  return (dispatch: Dispatch<any>) => {
    dispatch({type: actionTypes.GET_SLACK_LOGIN_LINK_FETCHED})

    Api.getSlackLoginLink()
      .then(res => {
        dispatch({
          type: actionTypes.GET_SLACK_LOGIN_LINK_SUCCESS,
          payload: res.data,
        })
      })
      .catch(err => {
        dispatch({
          type: actionTypes.GET_SLACK_LOGIN_LINK_FAILED,
          payload: err
        })
      })
  }
}

export function getConnectionLinks() {
  return async (dispatch: Dispatch<any>) => {
    try {
      const resp = await Api.getConnectionLinks();
      dispatch({
        type: actionTypes.GET_CONNECTION_LINKS_SUCCESS,
        payload: resp.data,
      })
    } catch (err) {
      dispatch({
        type: actionTypes.GET_CONNECTION_LINKS_ERROR,
        payload: err
      })
    }
  }
}

export function getSubscription() {
  return (dispatch: Dispatch<any>) => {
    dispatch({type: actionTypes.GET_SUBSCRIPTIONS_FETCHED})

    Api.getSubscriptions()
      .then(res => {
        const { result } = res.data;
        const slackSub = result.find((r:any) => r.platform === 'slack');
        if (slackSub) {
          getSlackMembers().then((resp) => {
            result.forEach((r:any) => {
              if (r.platform === 'slack') {
                r.allMembers = resp.data.result;
              }
            })
            dispatch({
              type: actionTypes.GET_SUBSCRIPTIONS_SUCCESS,
              payload: result
            })
          })
          return;
        }
        dispatch({
          type: actionTypes.GET_SUBSCRIPTIONS_SUCCESS,
          payload: result
        })
      })
      .catch(err => {
        dispatch({
          type: actionTypes.GET_SUBSCRIPTIONS_FAILED,
          payload: err
        })
      })
  }
}

export function getSlackMembers() {
  return Api.getSlackMembers();
}

export function getSearchData(text:string, subscriptions:Array<any>) {
  return (dispatch: Dispatch<any>) => {
    dispatch({type: actionTypes.SEARCH_DATA_FETCHED});

    Api.searchData(text, subscriptions)
      .then(res => {
        const { data } = res;
        dispatch({
          type: actionTypes.SEARCH_DATA_SUCCESS,
          payload: data,
        })
      })
      .catch(err => {
        dispatch({
          type: actionTypes.SEARCH_DATA_FAILED,
          payload: err,
        })
      })
  }
}

export function getBookmarks() {
  return (dispatch:Dispatch<any>) => {
    dispatch({type: actionTypes.GET_BOOKMARKS_FETCHED})

    Api.getBookmarks()
      .then(res => {
        if(res && res.data){
          dispatch({
            type: actionTypes.GET_BOOKMARKS_SUCCESS,
            payload: res.data,
          })
        }
        else{
          dispatch({
            type: actionTypes.GET_BOOKMARKS_FAILED,
            payload: res,
          })
        }
      })
      .catch(err => {
        dispatch({
          type: actionTypes.GET_BOOKMARKS_FAILED,
          payload: err,
        })
      })
  }
}

export function postBookmark(data: any) {
  return (dispatch:Dispatch<any>) => {
    dispatch({type: actionTypes.POST_BOOKMARK_FETCHED})

    Api.postBookmark(data)
      .then(res => {
        dispatch({
          type: actionTypes.POST_BOOKMARK_SUCCESS,
          payload: res,
        })
      })
      .catch(err => {
        dispatch({
          type: actionTypes.POST_BOOKMARK_FAILED,
          payload: err,
        })
      })
  }
}

export function deleteBookmark(data: any) {
  return (dispatch:Dispatch<any>) => {
    dispatch({type: actionTypes.DELETE_BOOKMARK_FETCHED})

    Api.deleteBookmark(data)
      .then(res => {
        dispatch({
          type: actionTypes.DELETE_BOOKMARK_SUCCESS,
          payload: res,
        })
      })
      .catch(err => {
        dispatch({
          type: actionTypes.DELETE_BOOKMARK_FAILED,
          payload: err,
        })
      })
  }
}

export function deleteBookmarkLocaly(data:any) {
  return ({
    type: actionTypes.DELETE_BOOKMARK_LOCALY,
    payload: data,
  })
}

export function feedbackFetch(data:any) {
  return (dispatch:Dispatch<any>) => {
    dispatch({type: actionTypes.FEEDBACK_DATA_FETCHED})

    Api.searchFeedback(data)
      .then(res => {
        dispatch({
          type: actionTypes.FEEDBACK_DATA_SUCCESS,
          payload: res.data,
        })
      })
      .catch(err => {
        dispatch({
          type: actionTypes.FEEDBACK_DATA_FAILED,
          payload: err,
        })
      })
  }
}

export function getPermalink(data:any) {
  return (dispatch:Dispatch<any>) => {
    dispatch({type: actionTypes.PERMALINK_DATA_FETCHED})

    Api.getPermalink(data)
      .then(res => {
        dispatch({
          type: actionTypes.PERMALINK_DATA_SUCCESS,
          payload: res.data,
        })
      })
      .catch(err => {
        dispatch({
          type: actionTypes.PERMALINK_DATA_FAILED,
          payload: err,
        })
      })
  }
}

export function deleteUser() {
  return (dispatch:Dispatch<any>) => {
    dispatch({type: actionTypes.DELETE_USER_FETCHED})

    Api.deleteUser()
      .then(res => {
        if(res.data.success){
          auth.clear();
          dispatch({
            type: actionTypes.DELETE_USER_SUCCESS,
            payload: res.data,
          })
        }
        else{
          dispatch({
            type: actionTypes.DELETE_USER_FAILED,
            payload: res.data,
          })
        }
      })
      .catch(err => {
        dispatch({
          type: actionTypes.DELETE_USER_FAILED,
          payload: err,
        })
      })
  }
}

export function dissconnectAccount(data:any) {
  return (dispatch:Dispatch<any>) => {
    dispatch({type: actionTypes.DISSCONNECT_ACCOUNT_FETCHED})

    Api.disconnectAccount(data)
      .then(res => {
        if(res.data.success){
          dispatch({
            type: actionTypes.DISSCONNECT_ACCOUNT_SUCCESS,
            payload: res.data,
          })
          dispatch(getSubscription());
        }
        else{
          dispatch({
            type: actionTypes.DISSCONNECT_ACCOUNT_FAILED,
            payload: res.data,
          })
        }
      })
      .catch(err => {
        dispatch({
          type: actionTypes.DISSCONNECT_ACCOUNT_FAILED,
          payload: err,
        })
      })
  }
}

export function signOut() {
  localStorage.clear();
  return ({
    type: actionTypes.SIGN_OUT
  })
}